import * as React from 'react'
import { FC } from 'react'

import { ENTITY_TYPES } from '@sales-center/common'
import { CreateAgreementFormWrapper } from './CreateAgreementForm/CreateAgreementFormWrapper'
import { SideDrawer } from './CreateAgreementDrawer/SideDrawer'
import { AgreementSource } from './typings'

interface Props {
  entityId: number
  entityType: ENTITY_TYPES
  externalLocationId: string
  onClose: () => void
  open: boolean
  openServicesDrawer: () => void
  openCreateServiceDrawer: () => void
  source?: AgreementSource
}

export const CreateAgreementsDrawer: FC<Props> = (props) => {
  const {
    entityId,
    entityType,
    externalLocationId,
    onClose,
    open,
    openServicesDrawer,
    openCreateServiceDrawer,
    source = 'detail',
  } = props

  return (
    <SideDrawer
      title="Create Agreement"
      open={open}
      onClose={onClose}
      width={495}
    >
      <CreateAgreementFormWrapper
        entityId={entityId}
        entityType={entityType}
        externalLocationId={externalLocationId}
        onClose={onClose}
        openServicesDrawer={openServicesDrawer}
        openCreateServiceDrawer={openCreateServiceDrawer}
        source={source}
      />
    </SideDrawer>
  )
}
CreateAgreementsDrawer.displayName = 'CreateAgreementsDrawer'
